import { Col, FormInstance, Row } from "antd";
import { CustomForm } from "../../Form/index.styled";
import { CheckableTagForm } from "./Form/CheckableTag";
import { RadioGroupForm } from "./Form/RadioGroup";

interface UserInfoServiceAirconFilterFormProps {
  form: FormInstance<any>;
  readonly?: boolean;
}

/**
 * 에어컨필터
 * @param param0
 * @returns
 */
export const UserInfoServiceAirconFilterForm: React.FC<
  UserInfoServiceAirconFilterFormProps
> = ({ form, readonly = false }) => {
  /**
   * 르노 및 국산차 핸들링
   * @param checked
   */
  const handleDomestic = (type: "renaul" | "domestic", checked: boolean) => {
    if (type === "renaul" && checked === true) {
      form.setFieldsValue({
        repairShopOption: {
          options: {
            services: {
              airconFilter: {
                domesticVehicleHandleable: checked,
              },
            },
          },
        },
      });
    }
    if (type === "domestic" && checked === false) {
      form.setFieldsValue({
        repairShopOption: {
          options: {
            services: {
              airconFilter: {
                renaultKoreaVehicleHandleable: checked,
              },
            },
          },
        },
      });
    }
  };

  return (
    <>
      <CustomForm.Item>
        <RadioGroupForm
          name={[
            "repairShopOption",
            "options",
            "services",
            "airconFilter",
            "isActivated",
          ]}
          rules={[
            {
              required: true,
            },
          ]}
          readonly={readonly}
        />
      </CustomForm.Item>
      <CustomForm.Item noStyle shouldUpdate>
        {({ getFieldValue }) =>
          getFieldValue([
            "repairShopOption",
            "options",
            "services",
            "airconFilter",
            "isActivated",
          ]) && (
            <CustomForm.Item
              name={["repairShopOption", "options", "services", "airconFilter"]}
              rules={[
                {
                  validator: (rule, value) => {
                    if (value && value?.isActivated === true) {
                      const checked = Object.entries(value).filter(
                        ([key, val]) => key !== "isActivated" && val === true
                      );

                      if (checked.length > 0) {
                        return Promise.resolve();
                      }
                    }
                    return Promise.reject(new Error("하나 이상 선택하세요."));
                  },
                },
              ]}
            >
              <Row gutter={[0, 8]}>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "airconFilter",
                      "domesticVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "airconFilter",
                        "domesticVehicleHandleable",
                      ])}
                      onChange={(checked: boolean) =>
                        handleDomestic("domestic", checked)
                      }
                      readonly={readonly}
                    >
                      국산차 (르노 외)
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "airconFilter",
                      "renaultKoreaVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "airconFilter",
                        "renaultKoreaVehicleHandleable",
                      ])}
                      onChange={(checked: boolean) =>
                        handleDomestic("renaul", checked)
                      }
                      readonly={readonly}
                    >
                      르노
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
                <Col>
                  <CustomForm.Item
                    name={[
                      "repairShopOption",
                      "options",
                      "services",
                      "airconFilter",
                      "incomeVehicleHandleable",
                    ]}
                  >
                    <CheckableTagForm
                      checked={form.getFieldValue([
                        "repairShopOption",
                        "options",
                        "services",
                        "airconFilter",
                        "incomeVehicleHandleable",
                      ])}
                      readonly={readonly}
                    >
                      수입차
                    </CheckableTagForm>
                  </CustomForm.Item>
                </Col>
              </Row>
            </CustomForm.Item>
          )
        }
      </CustomForm.Item>
    </>
  );
};
